module.exports = __webpack_public_path__ + "img/top.dffcc2f6.png";